module.exports = __webpack_public_path__ + "static/media/Mobile_NOSQL.6f6f9f97.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/banners/courses/NoSQL/Mobile_NOSQL.png
// module id = 68
// module chunks = 0